import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import EditableDescription from "@Broker/@Modules/clients/applications/documents/components/utils-components/editable-description.vue";
import Badge from "@Shared/components/general/badge.vue";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { useShowMoreToggle } from "@Shared/@Composables/generic/useShowMoreToggle";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "AutomationDocumentClassification",
  components: {
    InlinePrompt,
    EditableDescription,
    Badge
  },
  props: {
    document: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const labelValue = uuidv4();
    const {
      editing
    } = toRefs(props);
    const {
      showMore,
      showMoreButtonIcon,
      showMoreButtonText,
      toggleShowMore
    } = useShowMoreToggle();
    const {
      document
    } = toRefs(props);
    const showReadMoreButton = computed(() => {
      var _document$value$descr;
      return !editing.value && ((_document$value$descr = document.value.description) == null ? void 0 : _document$value$descr.length) > 28;
    });
    const handleEditDescription = $event => {
      emit("change-description", $event);
    };
    const handleDeleteDocument = () => {
      emit("delete-document");
    };
    return {
      labelValue,
      showReadMoreButton,
      showMore,
      showMoreButtonText,
      showMoreButtonIcon,
      toggleShowMore,
      handleEditDescription,
      handleDeleteDocument
    };
  }
});